<template>
  <div
    :class="
      twMerge(
        'relative flex items-start',
        { 'animation-pulse': isError },
        attrs.class,
      )
    "
  >
    <div class="flex h-5 items-center">
      <input
        :id="id"
        type="checkbox"
        :checked="checkedValue"
        @change="handleChange"
        :class="
          twMerge(
            'text-primary-500 focus-visible:ring-primary-200 h-4 w-4 rounded border-neutral-200 focus:ring-0 focus:ring-offset-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
            isError ? 'border-error-500' : '',
          )
        "
        :test_id="attrs.test_id"
        :disabled="isDisabled"
        :autocomplete="attrs.autocomplete"
        :tabindex="attrs.tabindex"
      />
    </div>
    <FormLabel
      class="ml-2"
      :class="{ 'text-error-500': isError }"
      :id="id"
      is-checkbox-label
      :is-required="isRequired"
      :tooltip="tooltip"
    >
      <slot />
    </FormLabel>
  </div>
</template>

<script setup>
import FormLabel from './FormLabel.vue'
import { computed, useAttrs, useId } from 'vue'
import { twMerge } from 'tailwind-merge'

const emit = defineEmits([
  'update:unchecked',
  'update:checked',
  'update:modelValue',
  'input',
])

const props = defineProps({
  modelValue: {
    type: [Array, Boolean],
    default: false,
  },
  value: {
    type: [String, Number],
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
  isError: {
    type: Boolean,
    default: false,
  },
})

const attrs = useAttrs()

const id = `growthmentor-checkbox-${useId()}`

const checkedValue = computed(() => {
  return Array.isArray(props.modelValue)
    ? props.modelValue.includes(props.value)
    : props.modelValue
})

const handleChange = () => {
  if (Array.isArray(props.modelValue)) {
    const checkboxArray = [...props.modelValue]
    if (checkboxArray.includes(props.value)) {
      checkboxArray.splice(checkboxArray.indexOf(props.value), 1)
      emit('update:unchecked', props.value)
    } else {
      checkboxArray.push(props.value)
      emit('update:checked', props.value)
    }
    emit('update:modelValue', checkboxArray)
    // 'input' emit is backward compatibility with Vue 2 v-model
    emit('input', checkboxArray)
  } else {
    const newCheckedValue = !props.modelValue
    if (newCheckedValue) {
      emit('update:checked', props.value)
    } else {
      emit('update:unchecked', props.value)
    }
    emit('update:modelValue', newCheckedValue)
    // 'input' emit is backward compatibility with Vue 2 v-model
    emit('input', newCheckedValue)
  }
}
</script>

<script>
export default {
  inheritAttrs: false,
}
</script>
